import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { motion } from 'framer-motion';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

const PDFViewer = ({ pdfUrl, onClose, title }) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-white z-50 overflow-auto flex flex-col items-center"
        >
            <div className="p-4 w-full max-w-3xl">
                <h2 className="text-2xl font-bold mb-4">{title}</h2>
                <Document
                    file={pdfUrl}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    <Page pageNumber={pageNumber} width={Math.min(600, window.innerWidth - 32)} />
                </Document>
                <p>Page {pageNumber} of {numPages}</p>
                <div className="flex justify-between mt-4">
                    <button
                        onClick={() => setPageNumber(page => Math.max(page - 1, 1))}
                        disabled={pageNumber <= 1}
                        className="bg-blue-500 text-white py-2 px-4 rounded disabled:bg-gray-300"
                    >
                        Previous
                    </button>
                    <button
                        onClick={() => setPageNumber(page => Math.min(page + 1, numPages))}
                        disabled={pageNumber >= numPages}
                        className="bg-blue-500 text-white py-2 px-4 rounded disabled:bg-gray-300"
                    >
                        Next
                    </button>
                </div>
                <button
                    onClick={onClose}
                    className="mt-4 bg-red-500 text-white py-2 px-4 rounded"
                >
                    Close
                </button>
            </div>
        </motion.div>
    );
};

export default PDFViewer;